import { TextFieldStyled } from 'components/@common/TextField/TextField.styles'

export const BaseInput = TextFieldStyled
